// extracted by mini-css-extract-plugin
export default {"tabs":"SecondaryTabsBar-module__tabs__OzNkB","tabsContainer":"SecondaryTabsBar-module__tabsContainer__0zPXT","indicator":"SecondaryTabsBar-module__indicator__nkneY"};